import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {getAmplitudeFavouritesEventProperties, IAmplitudeFavouritesEventParams} from "./get_amplitude_favourites_event_properties";

export const trackAmplitudeRemoveFromFavourites = (params: IAmplitudeFavouritesEventParams): void => {
    trackAmplitudeEvent("remove_from_favourites", {
        ...getAmplitudeFavouritesEventProperties(params),
        offer_source: "rp",
        external_source: null,
        offer_url: null
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {getAmplitudeFavouritesEventProperties, IAmplitudeFavouritesEventParams} from "./get_amplitude_favourites_event_properties";

export const trackAmplitudeRemoveFromFavourites = (params: IAmplitudeFavouritesEventParams): void => {
    trackAmplitudeEvent("remove_from_favourites", {
        ...getAmplitudeFavouritesEventProperties(params),
        offer_source: "rp",
        external_source: null,
        offer_url: null
    });
};
